<script setup>
import { Head, Link } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue'

defineProps({
    diary: Object
})
</script>

<script>
export default {
    mounted(){
        setTimeout(() => {
            if(this.diary.background_image){
                document.querySelector('section.page-header').style.background = 'url("' + this.asset(this.diary.background_image) + '")';
                document.querySelector('section.page-header').style.backgroundRepeat = 'no-repeat';
                document.querySelector('section.page-header').style.backgroundSize = 'cover';
            }
        }, 1000);
    }
}
</script>

<template>
    <AppLayout title="Neighbourhood Diary Inspire Properties" desc="Discovers a wide range of properties in Dubai and UAE with Inspire Properties">
        <template #header>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">Diaries</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Neighbourhood Diaries</li>
                </ol>
            </nav>
            <div>
                <h2 class="page-header-heading">{{ diary.title }}</h2>
            </div>
        </template>

        <section class="neighbourhood-diary">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9 mx-auto">
                        <div class="headings text-center">
                            <h2>As a Community</h2>
                            <p class="mt-3">
                               {{ diary.community }}
                            </p>
                            <!-- <a class="btn-custom2" href="FIXME:">
                                <span>List Your Home</span>
                                <div class="icon">
                                    <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
                                </div>
                            </a> -->
                        </div>
                    </div>
                </div>
                <div class="transportation-wrap">
                    <div class="row">
                        <div class="col-lg-6">
                            <figure class="mb-0">
                                <img :src="asset('/images/neighbourhood-diaries/transportation.jpg')" alt="transportation">
                            </figure>
                        </div>
                        <div class="col-lg-6">
                            <div class="transportation-content mt-5">
                                <div class="headings">
                                    <h2>
                                        Transportation
                                    </h2>
                                    <p></p>
                                    <div class="styled-list" v-html="diary.transportation"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="properties-wrap mt-5 mt-lg-0">
                    <div class="row justify-content-lg-between">
                        <div class="col-lg-6">
                            <figure class="mb-0">
                                 <img :src="asset('/images/neighbourhood-diaries/properties-to-offer.jpg')" alt="properties-to-offer">
                            </figure>
                        </div>
                        <div class="col-lg-5 mt-5 mt-lg-0">
                            <div class="properties-content">
                                <div class="headings">
                                    <h2>Properties to Offer</h2>
                                    <p>
                                        {{ diary.offer }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="target pt-0">
            <div class="container">
                <div class="row justify-content-end">
                    <div class="col-lg-7">
                        <figure class="mb-0">
                            <img :src="asset('/images/neighbourhood-diaries/dubai-properties.jpg')" alt="dubai-properties">
                        </figure>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-lg-7">
                        <div class="headings">
                            <h2 class="text-white">Targeted To</h2>
                            <p class="text-white">
                                {{ diary.targeted_to }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="current-assets property-listing-details">
            <div class="container-fluid px-lg-0">
                <div class="row align-items-center px-lg-0 mx-lg-0">
                     <div class="col-lg-6 ">
                        <div class="current-assets-content">
                            <div class="mb-4">
                                <div class="headings">
                                    <h4>Convenience</h4>
                                </div>
                                <div class="row mt-3 ms-xl-4">
                                    <div class="col-12 styled-list flexy-list" v-html="diary.convenience"></div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <div class="headings">
                                    <h4>Necessities</h4>
                                </div>
                                <div class="row mt-3 ms-xl-4">
                                    <div class="col-12 styled-list flexy-list" v-html="diary.necessities"></div>
                                </div>
                            </div>
                            <div class="">
                                <div class="headings">
                                    <h4>Social Destinations</h4>
                                </div>
                                <div class="row mt-3 ms-xl-4">
                                    <div class="col-12 styled-list flexy-list" v-html="diary.social_destinations"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 px-0 mt-5 mt-lg-0">
                        <div class="assets-img" v-html="diary.map">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </AppLayout>
</template>

<style>
.flexy-list ul{
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
}
.flexy-list ul li{
    flex: 0 0 auto;
    width: 45%;
    padding: 0px 12px;
}
</style>